import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Classificação CDD',
        path: '/biblioteca/bibclassificacao',
        name: 'bibclassificacao',
        component: () => import('@/views/biblioteca/bibclassificacao/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CLASSIFICACAODEOBRASNOVO_MENU_1300800399],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Classificações CDD',
        path: '/biblioteca/bibclassificacao/cadastro/:id?',
        parent: 'bibclassificacao',
        name: 'bibclassificacao_create',
        component: () => import('@/views/biblioteca/bibclassificacao/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CLASSIFICACAODEOBRASNOVO_MENU_1300800399],
        },
        goesToMenu: true,
    },
]
